// export default Dashboard;

import React, { useEffect } from "react";
import "../../styles/dashboard.css";
import Content from "../Content/content";
import Navbar from "../NavBar/Navbar";
import Menubar from "../sidebarFolder/menubar";
import { useDispatch, useSelector } from "react-redux";
import { AccessTockenReducer } from "../../Redux/store";
// import StickyFooter from "../NavBar/footer";
import "./dashbord.css";
import PrivateRoute from "../../routes/private_route";
import { BrowserRouter as Router, Route, Routes, Outlet, Navigate, NavLink,useNavigate } from 'react-router-dom';
import DashBoard from "../../Pages/DashBoard/DashBoard";
import Userlogin from "../Login/userlogin";
import ForgotPassword from "../Login/forgetPassword";
import Liceses from "../../Pages/Licenses/LicensesTable";
import Software from "../../Pages/Software/SoftwarePage";
import SalesOrder from "../../Pages/SalesOrder/SalesOrder";
import CreateOrder from "../../Pages/SalesOrder/CreateOrder";
import LiceseDetails from "../../Pages/Licenses/LicenseDetails";
import CompanyDetails from "../../Pages/Licenses/Companydetails";
import ResetPassword from '../../components/Login/resetPassword';

const MainContentWrapper = ({ children }) => (
  <div className="Main-Content-Wrapper">
   
 <div className="sidenav">
    <Menubar />
    </div>
 
      <div className="app-content"> 
      <Navbar />
      { children }
      </div>    
  </div>
);

function Dashboard(props) {
  //useEffect hook
  const dispatch = useDispatch();
  const toggled = useSelector((state) => state.AccessTocken.sidebarToggle);
  // const [toggled, setToggled] = useState(false);
  useEffect(() => { });
  const handleToggleSidebar = (toggled) => {
    dispatch(AccessTockenReducer.sidebar_toggle(toggled ? true : false));
    //setToggled(value);
  };

  

  return (
    <div className={`app  ${toggled ? "toggled" : ""}`}>
      
    <main>
    <Router>
          <Routes>
            <Route path="/dashboard" element={<PrivateRoute ><MainContentWrapper><DashBoard /></MainContentWrapper></PrivateRoute>} />
            <Route path="/liceses" element={<PrivateRoute ><MainContentWrapper><Liceses/></MainContentWrapper></PrivateRoute>} />
            <Route path="/Software" element={<PrivateRoute ><MainContentWrapper><Software/></MainContentWrapper></PrivateRoute>} />
            <Route path="/SalesOrder" element={<PrivateRoute ><MainContentWrapper><SalesOrder/></MainContentWrapper></PrivateRoute>} />
            <Route path="/CreateOrder" element={<PrivateRoute ><MainContentWrapper><CreateOrder/></MainContentWrapper></PrivateRoute>} />
            <Route path="/CreateOrder/?orderid=" element={<PrivateRoute><MainContentWrapper><CreateOrder /></MainContentWrapper></PrivateRoute>} />
            <Route path="/LiceseDetails/:te_lmsid" element={<PrivateRoute ><MainContentWrapper><LiceseDetails/></MainContentWrapper></PrivateRoute>} />
            {/* <Route path="/app-down" element={<PrivateRoute > <AppDown /> </PrivateRoute>} /> */}
            <Route path="/CompanyDetails/:te_companyid/:te_lmsid" element={<PrivateRoute ><MainContentWrapper><CompanyDetails/></MainContentWrapper></PrivateRoute>} />
            <Route path="/login" element={<Userlogin  />} />
            <Route path="/ForgotPassword" element={<ForgotPassword  />} />
            <Route path="/resetPassword" element={<ResetPassword  />} />
            {/* </Route> */}
            <Route path="/" element={sessionStorage.getItem("access_token") ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
            {/* <Route path="/forgotPassword" element={<ForgotPassword/>}/>
  <Route path="/resetPassword/:id" element={<ResetPassword/>}/> */}
          </Routes>
        </Router>
    </main>
  </div>
  );
}

export default Dashboard;
